import React from 'react';
import { Scissors, Volume2, Sparkles, Wand2, ZoomIn, Film } from 'lucide-react';
import { RawVideoUploader } from './RawVideoUploader.jsx';

export function AutoEditorControls({
  cutSilences,
  onChangeCutSilences,
  neonCaptions,
  onChangeNeonCaptions,
  captionAccent,
  onChangeCaptionAccent,
  entranceZoom,
  onChangeEntranceZoom,
  audioMaster,
  onChangeAudioMaster,
  onTriggerAutoEdit,
  isProcessing,
  transcriptText,
  onChangeTranscriptText,
  onVideoUploaded,
  currentVideoUrl
}) {
  const ACCENT_OPTIONS = [
    { id: 'neon', label: 'Neón Morado #7906fb', color: '#a855f7' },
    { id: 'gold', label: 'Titanium Oro #ff9101', color: '#ff9101' },
    { id: 'white', label: 'Blanco Puro #ffffff', color: '#ffffff' }
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
      <div style={{
        padding: '12px',
        background: 'linear-gradient(135deg, rgba(255, 145, 1, 0.08), rgba(168, 85, 247, 0.08))',
        borderRadius: '10px',
        border: '1px solid rgba(255, 145, 1, 0.25)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#ff9101', fontSize: '12px', fontWeight: 700, marginBottom: '4px' }}>
          <Sparkles size={14} /> Suite de Post-Producción Automática
        </div>
        <p style={{ fontSize: '11px', color: '#94a3b8', lineHeight: '1.4' }}>
          Corte de aire con respiro orgánico, Dynamic Entrance Zoom 1.08x, subtítulos karaoke con cursor luminoso y masterización -14 LUFS.
        </p>
      </div>

      {/* Ingesta de Video RAW Propio */}
      <RawVideoUploader
        onVideoUploaded={onVideoUploaded}
        currentVideoUrl={currentVideoUrl}
      />

      {/* Toggle 1: Corte de Silencios con Respiro (Breathe EDL) */}
      <div style={{
        background: '#141724',
        padding: '12px',
        borderRadius: '10px',
        border: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer'
      }} onClick={() => onChangeCutSilences(!cutSilences)}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ background: 'rgba(168,85,247,0.15)', padding: '6px', borderRadius: '6px', color: '#c084fc' }}>
            <Scissors size={16} />
          </div>
          <div>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#f8fafc' }}>Corte de Silencios con Respiro</div>
            <div style={{ fontSize: '10px', color: '#94a3b8' }}>Breathe EDL (evita butt-joins secos, +0.16s orgánico)</div>
          </div>
        </div>
        <input
          type="checkbox"
          checked={cutSilences}
          onChange={(e) => onChangeCutSilences(e.target.checked)}
          style={{ width: '16px', height: '16px', accentColor: '#a855f7', cursor: 'pointer' }}
        />
      </div>

      {/* Toggle 2: Entrance Zoom 1.08x */}
      <div style={{
        background: '#141724',
        padding: '12px',
        borderRadius: '10px',
        border: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer'
      }} onClick={() => onChangeEntranceZoom(!entranceZoom)}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ background: 'rgba(255,145,1,0.15)', padding: '6px', borderRadius: '6px', color: '#ff9101' }}>
            <ZoomIn size={16} />
          </div>
          <div>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#f8fafc' }}>Push-In Cinemático de Entrada</div>
            <div style={{ fontSize: '10px', color: '#94a3b8' }}>Entrance Zoom 1.08x → 1.00x en los primeros 1.2s</div>
          </div>
        </div>
        <input
          type="checkbox"
          checked={entranceZoom}
          onChange={(e) => onChangeEntranceZoom(e.target.checked)}
          style={{ width: '16px', height: '16px', accentColor: '#ff9101', cursor: 'pointer' }}
        />
      </div>

      {/* Toggle 3: Subtítulos Karaoke Neón / Glow */}
      <div style={{
        background: '#141724',
        padding: '12px',
        borderRadius: '10px',
        border: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
      }}>
        <div
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
          onClick={() => onChangeNeonCaptions(!neonCaptions)}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ background: 'rgba(168,85,247,0.15)', padding: '6px', borderRadius: '6px', color: '#c084fc' }}>
              <Sparkles size={16} />
            </div>
            <div>
              <div style={{ fontSize: '12px', fontWeight: 700, color: '#f8fafc' }}>Subtítulos Karaoke Dinámicos</div>
              <div style={{ fontSize: '10px', color: '#94a3b8' }}>Estilo #06 Hormozi/Luminorphism en Montserrat ExtraBold</div>
            </div>
          </div>
          <input
            type="checkbox"
            checked={neonCaptions}
            onChange={(e) => onChangeNeonCaptions(e.target.checked)}
            style={{ width: '16px', height: '16px', accentColor: '#a855f7', cursor: 'pointer' }}
          />
        </div>

        {neonCaptions && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', paddingTop: '8px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
            <label style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', color: '#94a3b8' }}>Acento de Brillo / Glow</label>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px' }}>
              {ACCENT_OPTIONS.map((acc) => {
                const isSelected = captionAccent === acc.id;
                return (
                  <button
                    key={acc.id}
                    type="button"
                    onClick={() => onChangeCaptionAccent(acc.id)}
                    style={{
                      padding: '6px 4px',
                      borderRadius: '6px',
                      fontSize: '10px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      background: isSelected ? 'rgba(168,85,247,0.2)' : '#0d0f17',
                      color: isSelected ? '#f8fafc' : '#94a3b8',
                      border: isSelected ? '1px solid rgba(192,132,252,0.7)' : '1px solid rgba(255,255,255,0.06)'
                    }}
                  >
                    {acc.label}
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* Toggle 4: Audio Master -14 LUFS */}
      <div style={{
        background: '#141724',
        padding: '12px',
        borderRadius: '10px',
        border: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer'
      }} onClick={() => onChangeAudioMaster(!audioMaster)}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ background: 'rgba(52,211,153,0.15)', padding: '6px', borderRadius: '6px', color: '#34d399' }}>
            <Volume2 size={16} />
          </div>
          <div>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#f8fafc' }}>Audio Master EBU R128 (-14 LUFS)</div>
            <div style={{ fontSize: '10px', color: '#94a3b8' }}>Normalización 48 kHz Estéreo AAC para YouTube</div>
          </div>
        </div>
        <input
          type="checkbox"
          checked={audioMaster}
          onChange={(e) => onChangeAudioMaster(e.target.checked)}
          style={{ width: '16px', height: '16px', accentColor: '#34d399', cursor: 'pointer' }}
        />
      </div>

      {/* Transcript Input opcional para captions */}
      {neonCaptions && (
        <div>
          <label style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', color: '#94a3b8', display: 'block', marginBottom: '6px' }}>
            Transcripción para Subtítulos Karaoke
          </label>
          <textarea
            value={transcriptText}
            onChange={(e) => onChangeTranscriptText(e.target.value)}
            placeholder="Escribe o pega el texto para sincronizar con los subtítulos..."
            rows={3}
            style={{
              width: '100%',
              background: '#141724',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: '8px',
              padding: '10px',
              color: '#f8fafc',
              fontSize: '12px',
              resize: 'none',
              outline: 'none',
              fontFamily: 'inherit'
            }}
          />
        </div>
      )}

      {/* Action Button */}
      <button
        type="button"
        onClick={onTriggerAutoEdit}
        disabled={isProcessing}
        style={{
          width: '100%',
          padding: '14px',
          borderRadius: '10px',
          background: 'linear-gradient(135deg, #ff9101 0%, #a855f7 100%)',
          color: '#fff',
          fontWeight: 700,
          fontSize: '14px',
          border: 'none',
          cursor: isProcessing ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          boxShadow: '0 4px 20px rgba(255, 145, 1, 0.35)',
          transition: 'all 0.2s',
          marginTop: 'auto'
        }}
      >
        <Wand2 size={16} />
        {isProcessing ? 'Procesando Auto-Edición...' : '⚡ Aplicar Post-Producción Automática'}
      </button>
    </div>
  );
}
